import React, { useContext } from "react";
import { ConfigContext } from "../Config/ConfigContext";
import {  useParams } from "react-router-dom";
import http from "../utils/http";
import auth from "../utils/auth";

const TenantInvite = ({redirectRoute = "/"}) => {
    const { tenantId } = useParams();
    const { config } = useContext(ConfigContext);
    const [apiError, setApiError] = React.useState(null);

    async function acceptTenantInvite() {
        const result = await http.get({},`${config.uri.base}/tenant/acceptInvite/${tenantId}`);

        if (result?.error) {
            setApiError(result.error + " " + result.errorType);
        }
    }

    async function switchTenants() {
        const platformJWT = await http.get(
            {},
            `${config.uri.base}/tenant/switch?tenantId=${tenantId}`
        );

        if (platformJWT?.error) {
            setApiError(platformJWT.error + " " + platformJWT.errorType);
        }

        auth.setBearerToken(platformJWT);

        window.location.href = redirectRoute;
    }

    return (
        <div className="tenantJoinedContainer">
            <div className="optionalBreakpointContainer">
                <h1 className="tenantJoinedHeader">Tenant successfully joined!</h1>
                <p className="tenantJoinedText">
                    Ready to{" "}
                    <button
                        className="acceptInviteButton"
                        onClick={async () => {
                            await acceptTenantInvite();
                            await switchTenants();
                        }}
                    >
                        switch tenants?
                    </button>
                </p>

                {apiError && (
                    <div className="tenantApiError">
                        <p>{apiError}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TenantInvite;
